const contentLocalization = {
  en: {
    remainWatch: 'remain',
    season: 'Season',
    episode: 'Episode',
    episodes: 'Episodes',
    noProgData: 'No program data',
    catalogAllFilter: 'All',
    catalogContent: 'Content',
    catalogSource: 'Source',
    catalogGenre: 'Genre',
    catalogYear: 'Year',
    catalogCountry: 'Country',
    catalogSorting: 'Sorting',
    catalogApply: 'Apply',
    catalogReset: 'Reset',
    searchFilter: 'Filter',
    searchFilterReset: 'Reset filter',
    searchHistory: 'Search history',
    searchNotFound: 'Not found',
    recentlySearch: 'Recently search',
    searchResult: 'Search result',
    watch: 'Watch',
    continueWatching: 'Continue watching',
    subscribe: 'Subscribe',
    subscribing: 'Subscribing',
    selectEpisode: 'Seasons and episodes',
    movieReview: 'Review',
    aboutMovie: 'About movie',
    movieDuration: 'Duration',
    movieAgeRate: 'Age rating',
    creatorsAndActors: 'Creators and actors',
    director: 'Director',
    producer: 'Producer',
    roles: 'Roles',
    seeAlso: 'See also',
    history: 'Watch history',
    favorites: 'Favorites',
    channelAddedToFavorite: 'Channel added to favorites',
    channelRemovedFromFavorite: 'Channel removed from favorites',
    movieAddedToFavorite: 'Movie added to favorites',
    movieRemovedFromFavorite: 'Movie removed from favorites',
    nextEpisode: 'Next episode',
    playerFitMode: 'Fit mode',
    fitMode: 'Fit',
    fillMode: 'Fill',
    coverMode: 'Cover',
    zoomMode: 'Zoom',
    quality: 'Video quality',
    qualityAuto: 'Auto',
    audio: 'Audio',
    subtitles: 'Subtitles',
    subtitlesOff: 'Off',
    debugInfo: 'Debug info',
    startLive: 'Start live',
    epgResult: 'Programs',
    filmsResult: 'Films',
    seriesResult: 'Series',
    multsResult: 'Mults',
    showsResult: 'Shows',
    favoritesTvChannels: 'Channels',
  },
  ru: {
    remainWatch: 'осталось',
    season: 'Сезон',
    episode: 'Серия',
    episodes: 'Серии',
    noProgData: 'Программа передач отсутствует',
    catalogAllFilter: 'Все',
    catalogContent: 'Контент',
    catalogSource: 'Источник',
    catalogGenre: 'Жанр',
    catalogYear: 'Год',
    catalogCountry: 'Страна',
    catalogSorting: 'Сортировка',
    catalogApply: 'Применить',
    catalogReset: 'Сбросить',
    searchFilter: 'Фильтр',
    searchFilterReset: 'Сбросить фильтр',
    searchHistory: 'История поиска',
    searchNotFound: 'По вашему запросу ничего не найдено',
    recentlySearch: 'Недавно искали',
    searchResult: 'Результаты поиска',
    watch: 'Смотреть',
    continueWatching: 'Продолжить просмотр',
    subscribe: 'Оформить подписку',
    subscribing: 'Оформление подписки',
    selectEpisode: 'Сезоны и серии',
    movieReview: 'Сюжет',
    aboutMovie: 'О фильме',
    movieDuration: 'Длительность',
    movieAgeRate: 'Ограничение',
    creatorsAndActors: 'Создатели и актёры',
    director: 'Режиссёр',
    producer: 'Продюсер',
    roles: 'В ролях',
    seeAlso: 'Смотрите также',
    history: 'История просмотра',
    favorites: 'Избранное',
    channelAddedToFavorite: 'Канал добавлен в избранное',
    channelRemovedFromFavorite: 'Канал удалён из избранного',
    movieAddedToFavorite: 'Фильм добавлен в избранное',
    movieRemovedFromFavorite: 'Фильм удалён из избранного',
    nextEpisode: 'Следующая серия',
    playerFitMode: 'Режим масштабирования',
    fitMode: 'Вместить',
    fillMode: 'Растянуть',
    coverMode: 'Заполнить',
    zoomMode: 'Увеличить',
    quality: 'Качество изображения',
    qualityAuto: 'Авто',
    audio: 'Аудио',
    subtitles: 'Субитиры',
    subtitlesOff: 'Выкл.',
    debugInfo: 'Отладочная информация',
    startLive: 'Перейти в эфир',
    epgResult: 'Программа передач',
    filmsResult: 'Фильмы',
    seriesResult: 'Сериалы',
    multsResult: 'Мультфильмы',
    showsResult: 'Шоу',
    favoritesTvChannels: 'ТВ-каналы',
  },
};

export default contentLocalization;
